import { Component, Input } from '@angular/core';
import {
  ImpattoIro,
  Opportunita,
  Rischio,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';

@Component({
  selector: 'app-tooltip-variabili-iro',
  standalone: false,

  templateUrl: './tooltip-variabili-iro.component.html',
  styleUrl: './tooltip-variabili-iro.component.scss',
})
export class TooltipVariabiliIroComponent {
  private _tipoIro: string | undefined;

  private _iro: any;

  @Input()
  get iro(): any {
    return this._iro;
  }

  set iro(value: any) {
    this._iro = value;
  }
  @Input()
  get tipoIro(): string | undefined {
    return this._tipoIro;
  }

  set tipoIro(value: string | undefined) {
    this._tipoIro = value;
  }

  haVariabili(iro: any): boolean {
    if (!iro) return false;

    // helper function
    const hasValue = (v: unknown): boolean => {
      if (v === null || v === undefined) return false;
      if (typeof v === 'string') return v.trim().length > 0;
      if (Array.isArray(v)) return v.length > 0;
      if (typeof v === 'object') return Object.keys(v).length > 0;
      return true; // numeri, booleani
    };

    return [
      iro.impattoPotenzialeEffettivo,
      iro.impattoPositivoNegativo,
      iro.impattoDirettoIndiretto,
      iro.fonte,
      iro.catene,
      iro.orizzontiTemporali,
    ].some(hasValue);
  }

  /**
   * Conversione stringa UPERCASE to LOWERCASE tranne la prima lettera
   * @param str
   * @returns
   */
  upperToLowerCase(str: string): string {
    if (!str) return str; // Se la stringa è vuota, la restituisce così com'è
    return str[0] + str.slice(1).toLowerCase(); // tutto lower case tranne la prima lettera
  }
}
